import React, { Component } from "react";
import { Router } from "react-router-dom";

//History
import history from "./Components/_Utils/History";

//Components
import RouterComponent from "./RouterComponent";

export default class App extends Component {
  render() {
    return (
      <div className="App">
        <Router history={history}>
          <RouterComponent />
        </Router>
      </div>
    );
  }
}
